import { render, staticRenderFns } from "./ResponsibleSearch.vue?vue&type=template&id=ddef23cc&scoped=true&"
import script from "./ResponsibleSearch.vue?vue&type=script&lang=js&"
export * from "./ResponsibleSearch.vue?vue&type=script&lang=js&"
import style0 from "./ResponsibleSearch.vue?vue&type=style&index=0&id=ddef23cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddef23cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/maplebear-pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout})
